import { render, staticRenderFns } from "./STRIPESUB.vue?vue&type=template&id=1c38b3fd&scoped=true&"
import script from "./STRIPESUB.vue?vue&type=script&lang=js&"
export * from "./STRIPESUB.vue?vue&type=script&lang=js&"
import style0 from "./STRIPESUB.vue?vue&type=style&index=0&id=1c38b3fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38b3fd",
  null
  
)

export default component.exports